export enum AddLineItemActionId {
  AddDescription = 'add-description',
  AddSubtotal = 'add-subtotal',
}
